export const DEFAULT_PAGE_SIZE = 10;
export const ITEM_ON_PAGE = 3;
export const START_PAGINATION_PAGE = 1;
